import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import EmailForm from './pages/EmailForm';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className='footer-container'>
      {/* Wave divider */}
      <div className='footer-wave'>
        <svg viewBox="0 0 1200 100" preserveAspectRatio="none">
          <path d="M0,0 C600,100 600,0 1200,100 L1200,0 L0,0 Z" fill="#4e54c8" />
        </svg>
      </div>

      <div className='footer-content'>
        {/* Left Section: Logo + Copyright */}
        <div className='footer-left'>
          <Link to='/' className='footer-logo'>
            PA
            <i className='fab fa-typo3'></i>
          </Link>
          <small className='footer-rights'>© {currentYear} Piyush Agarwal. All Rights Reserved.</small>
          <p className='footer-note'>Made with ❤️ using React.js</p>
        </div>

        {/* Right Section: Social Icons + Quick Links */}
        <div className='footer-right'>
          <div className='footer-links'>
            <Link to='/'>Home</Link>
            <Link to='/Services'>About</Link>
            <Link to='/Contact'>Contact</Link>
          </div>

          <div className='social-icons'>
            <Link className='social-icon' to='https://github.com/piyushagarwal14/' target='_blank' aria-label='GitHub' title='GitHub'>
              <i className='fab fa-github'></i>
            </Link>
            <Link className='social-icon' to='https://www.linkedin.com/in/piyush-agarwal-85b0301ba/' target='_blank' aria-label='LinkedIn' title='LinkedIn'>
              <i className='fab fa-linkedin'></i>
            </Link>
            <Link className='social-icon' to='https://www.instagram.com/piyushagarwal34/' target='_blank' aria-label='Instagram' title='Instagram'>
              <i className='fab fa-instagram'></i>
            </Link>
            <Link className='social-icon' to='https://www.behance.net/piyushagrawal7/' target='_blank' aria-label='Behance' title='Behance'>
              <i className='fab fa-behance'></i>
            </Link>
            <Link className='social-icon' to='https://dribbble.com/Piyush55' target='_blank' aria-label='Dribbble' title='Dribbble'>
              <i className='fab fa-dribbble'></i>
            </Link>
            {/* <Link className='social-icon' to='https://www.credly.com/users/piyush-agarwal.4f9f77cb' target='_blank' aria-label='Credly' title='Credly'>
              <img src='http://svgrepo.com/show/331358/credly.svg' alt='Credly' width={25} />
            </Link> */}
          </div>
        </div>
      </div>

      <div>
        <EmailForm/>
      </div>

      {/* Scroll to top button */}
      <button
        className='scroll-top'
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        title='Back to top'
      >
        ↑
      </button>
    </footer>
  );
}

export default Footer;
